import { MetricField } from "@/__generated__/graphql";
import { gql, useSuspenseQuery } from "@apollo/client";

interface UseDeviceHistoricalDataProps {
  deviceId: string;
  metric: MetricField;
  timeRange?: {
    from: number;
    to: number;
  };
}

const GET_DEVICE_HISTORICAL_DATA = gql(`#graphql
  query GetDeviceHistoricalData($input: DeviceInput!, $timeseriesInput2: MetricTimeseriesInput) {
    device(input: $input) {
      metrics {
        id
        timeseries(input: $timeseriesInput2) {
          data
          unit
        }
      }
    }
  }
`)


export const useDeviceHistoricalData = ({
  deviceId,
  metric,
  timeRange,
}: UseDeviceHistoricalDataProps) => {
  const { data, error } = useSuspenseQuery(GET_DEVICE_HISTORICAL_DATA, {
    variables: {
      input: { id: deviceId },
      timeseriesInput2: {
        parameters: { start: "-7d", window: "3h" },
        fields: [{ "metricField": metric }]
      },
    }
  });

  const historicalData: [number, number][] = data?.device?.metrics?.timeseries?.[0].data ?? [];
  const unit = data?.device?.metrics?.timeseries?.[0].unit ?? null;

  return {
    historicalData,
    unit,
    error,
  };
};